import { render, staticRenderFns } from "./SetHome.vue?vue&type=template&id=09a0b1c5"
import script from "./SetHome.vue?vue&type=script&lang=js"
export * from "./SetHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports